module.exports = __webpack_public_path__ + "console/img/machinecore_logo_small_final@1x.d714eb8a.png";